import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import FormCheckboxField from '@adv-mt/mt-form-checkbox-field'

import {LEGACY_WRAPPER} from './config.js'

const FormOnlyPeninsula = ({id, value, onChange, type, wrapper = LEGACY_WRAPPER}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {checked}) => {
    setTimeout(() => {
      onChange(e, {
        field: FILTER_NAMES.ONLY_PENINSULA,
        value: checked,
        lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.ONLY_PENINSULA]
      })
    }, 0)
  }

  const handleChecked = ({value: selectedValue}) => {
    const [currentValue] = selectedValue

    _handleOnChange(null, {checked: currentValue})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <FormCheckboxField
        checked={value}
        helpText={i18n.t('FORM.ONLY_PENINSULA.DESCRIPTION')}
        id={id || FILTER_NAMES.ONLY_PENINSULA}
        label={i18n.t('FORM.ONLY_PENINSULA.TITLE')}
        onChange={_handleOnChange}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          label: i18n.t('FORM.ONLY_PENINSULA.TITLE'),
          name: FILTER_NAMES.ONLY_PENINSULA,
          options: [{id: true, label: i18n.t('FORM.ONLY_PENINSULA.TITLE')}],
          type
        }
      ]}
      group={`${FILTER_NAMES.ONLY_PENINSULA}Group`}
      helpText={i18n.t('FORM.ONLY_PENINSULA.DESCRIPTION')}
      legend={i18n.t('FORM.ONLY_PENINSULA.TITLE')}
      onChange={handleChecked}
      value={{[FILTER_NAMES.ONLY_PENINSULA]: [value]}}
      wrapper={wrapper}
    />
  )
}

FormOnlyPeninsula.displayName = 'FormOnlyPeninsula'
FormOnlyPeninsula.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  wrapper: PropTypes.string
}

export default FormOnlyPeninsula
